import { computed, ref } from 'vue'
import { getPrincipal, type ClientPrincipal } from '@/api/auth'

// Shared, load-once auth state. Server-side route rules remain authoritative;
// this only shapes the UI.
const principal = ref<ClientPrincipal | null>(null)
const loaded = ref(false)

const isAuthenticated = computed(() => principal.value !== null)

export function useAuth() {
  async function load(force = false) {
    if (loaded.value && !force) return
    principal.value = await getPrincipal()
    loaded.value = true
  }
  return { principal, loaded, isAuthenticated, load }
}
